module.exports = __webpack_public_path__ + "img/album07_21.ebe2c1f1.jpg";